var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMetadataTagsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6982 2.5C14.5537 2.50001 15.3683 2.86536 15.9375 3.50391L18.7393 6.64648C19.1679 7.12728 19.4287 7.73155 19.4873 8.36816L19.5 8.64258V18.5C19.5 20.1569 18.1569 21.5 16.5 21.5H7.5L7.3457 21.4961C5.81166 21.4184 4.58163 20.1883 4.50391 18.6543L4.5 18.5V5.5L4.50391 5.3457C4.58163 3.81166 5.81166 2.58163 7.3457 2.50391L7.5 2.5H13.6982ZM13.8213 7.83398C13.8213 7.97196 13.9333 8.08383 14.0713 8.08398H17.8906C17.8266 7.92433 17.7365 7.77504 17.6201 7.64453L14.8184 4.50195C14.5612 4.21348 14.2034 4.03732 13.8213 4.00586V7.83398ZM6 18.5C6 19.3284 6.67157 20 7.5 20H16.5C17.3284 20 18 19.3284 18 18.5V9.58398H14.0713C13.1049 9.58383 12.3213 8.80039 12.3213 7.83398V4H7.5C6.67157 4 6 4.67158 6 5.5V18.5Z",
    fill: "#1A1B1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetadataTagsIcon);
export default __webpack_public_path__ + "static/media/metadata-tags-icon.821bbbe89f168607e9593c9dfa26ac0d.svg";
export { ForwardRef as ReactComponent };